import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import InvoiceView from '../../../../features/InvoiceView/InvoiceView';
import LibModal from '../../../../features/LibModal/LibModal';
import NotFound from '../../../../features/NotFound/NotFoundPage';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import cn from '../../../../utils/cn';
import InvoiceInfoRightCol from './Components/InvoiceInfoRightCol';
import PageHeader from './Components/PageHeader';
import InvoiceInfoProvider, { useInvoiceInfo } from './InvoiceInfoProvider';
import ModalAddNewServiceItem from './Modals/ModalAddNewServiceItem';
import ModalConvertQuotationToInvoice from './Modals/ModalConvertQuotationToInvoice';
import ModalInvoiceAuthorize from './Modals/ModalInvoiceAuthorize';
import ModalUpdateInvoiceBillingInfo from './Modals/ModalUpdateInvoiceBillingInfo';
import ModalUpdateInvoiceNumber from './Modals/ModalUpdateInvoiceNumber';
import ModalUpdateInvoiceTitle from './Modals/ModalUpdateInvoiceTitle';
import ModalUpdateQuotationNumber from './Modals/ModalUpdateQuotationNumber';
import ModalUpdatePaymentInfo from './Modals/ModalUpdatePaymentInfo';
import PaymentReceiveModal from './Modals/PaymentReceiveModal';
import UpdateInvoiceNoteModal from './Modals/UpdateInvoiceNoteModal';

function PageContentBody({ myRef, isReceipt }) {
    const { handleReload, invoiceInfo, headerLessPrint } = useInvoiceInfo();
    if (invoiceInfo && Object.keys(invoiceInfo).length === 0) {
        return (
            <div className="mt-10">
                <NotFound
                    title="Invoice Not Found!"
                    btnTitle="Reload"
                    evButtonClick={handleReload}
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div
            className={cn(
                `print:w-full flex flex-col xl:flex-row print:flex-none gap-5 justify-between items-stretch`,
                {
                    'placeholder-mode': invoiceInfo?.demo,
                    'justify-center': isReceipt
                }
            )}
        >
            <div
                className={cn(`w-full xl:w-[calc(100%_-_350px)] print:w-full`, {
                    'w-full': isReceipt,
                    '': headerLessPrint
                })}
                id="printInvoicePage"
                ref={myRef}
            >
                <InvoiceView info={invoiceInfo} isHeaderLessPrint={headerLessPrint} />
            </div>
            <div
                className={cn(
                    `w-full xl:w-[350px] print:w-0 print:hidden print:overflow-hidden h-full`,
                    {
                        'w-0 overflow-hidden hidden': isReceipt
                    }
                )}
            >
                <InvoiceInfoRightCol
                    invoiceData={invoiceInfo?.invoice}
                    billingAddress={invoiceInfo?.billingAddress}
                    invoiceItems={invoiceInfo?.invoiceItems}
                />
            </div>
        </div>
    );
}

function PageContent() {
    const { modalType, closeModal } = useTemplate();
    const { invoiceInfo } = useInvoiceInfo();
    const { state } = useLocation();

    const isReceipt = state?.title === 'Receipt';
    const invInfo = invoiceInfo?.invoice;
    // set page title
    // Set document title
    useEffect(() => {
        document.title = invInfo?.isQuotation ? invInfo?.quotationNo : invInfo?.customInvoiceNo;
    }, [invInfo]);

    return (
        <div className="inner_page_cont flex print:flex-none justify-center mb-10 print:mb-0">
            <div className="w-[1170px] print:w-full">
                <PageHeader isReceipt={isReceipt} />
                <PageContentBody isReceipt={isReceipt} />
            </div>

            {/* modals */}
            {modalType === 'payment-receive' && (
                <LibModal title="Receive Payment" setOpen={closeModal}>
                    <PaymentReceiveModal />
                </LibModal>
            )}

            {modalType === 'invoice_authorize' && (
                <LibModal title="Authorize Invoice" setOpen={closeModal}>
                    <ModalInvoiceAuthorize />
                </LibModal>
            )}
            {modalType === 'update_invoice_note' && (
                <LibModal title="Update Invoice Comment" setOpen={closeModal}>
                    <UpdateInvoiceNoteModal />
                </LibModal>
            )}
            {modalType === 'update_invoice_custom_number' && (
                <LibModal title="Update Invoice No." setOpen={closeModal}>
                    <ModalUpdateInvoiceNumber />
                </LibModal>
            )}
            {modalType === 'update_quotation_number' && (
                <LibModal title="Update Quotation No." setOpen={closeModal}>
                    <ModalUpdateQuotationNumber />
                </LibModal>
            )}
            {modalType === 'UPDATE_INVOICE_TITLE' && (
                <LibModal title="Update Title" setOpen={closeModal} className="!w-[400px]">
                    <ModalUpdateInvoiceTitle />
                </LibModal>
            )}
            {modalType === 'update_invoice_billing_info' && (
                <LibModal title="Update Billing Info" setOpen={closeModal}>
                    <ModalUpdateInvoiceBillingInfo />
                </LibModal>
            )}
            {modalType === 'add_new_service_item_to_invoice' && (
                <LibModal title="Add New Service Item" setOpen={closeModal} className="!w-[900px]">
                    <ModalAddNewServiceItem />
                </LibModal>
            )}
            {modalType === 'CONVERT_QUOTATION_TO_INVOICE' && (
                <LibModal
                    title="Turn to Invoice"
                    setOpen={closeModal}
                    className="[&>div>div>h1]:normal-case"
                >
                    <ModalConvertQuotationToInvoice />
                </LibModal>
            )}
            {modalType === 'UPDATE_INVOICE_PAYMENT_INFO' && (
                <LibModal
                    title="Update Payment Info"
                    setOpen={closeModal}
                    className="[&>div>div>h1]:normal-case"
                >
                    <ModalUpdatePaymentInfo />
                </LibModal>
            )}
        </div>
    );
}

function InvoiceInfoPage() {
    const { invoiceId } = useParams();

    return (
        <InvoiceInfoProvider id={invoiceId}>
            <PageContent />
        </InvoiceInfoProvider>
    );
}

export default InvoiceInfoPage;
